import { inject, onMounted, onUnmounted, reactive, nextTick } from "vue";
import { useRoute } from "vue-router";
import { store } from "../store";
import Segments from "./Segments";
import axiosLib from "axios";
import { useScrollState } from "@/composables/useScrollState";

const { ProductListViewedNonLoggedIn } = Segments();

export default function Categories() {
  const axios = inject("axios");
  const route = useRoute();

  // Set offset for scroll loading based on window height
  let offset = 12;
  const windowHeight = window.innerHeight;
  if (windowHeight > 1450) {
    offset = 24;
  } else if (windowHeight > 1100) {
    offset = 18;
  }
  const normalOffset = offset;

  const categories = reactive({
    loading: false,
    data: [],
    error: "",
  });

  let currentSource = null;
  const CancelToken = axiosLib.CancelToken;

  const getCategories = async (val = null) => {
    let filter = val ? val.value.map((c) => c.slug) : null;
    categories.loading = true;
    let user_id = localStorage.getItem('user_id') ?? null;
    axios.api
      .get("/categories", {
        params: {
          brand: filter,
          user_id: user_id,
        },
      })
      .then((resp) => {
        if (resp.status) {
          let data = resp.data.data;
          if (store.getters.cart.price_list_id == "33") {
            categories.data = data;
          } else {
            categories.data = data.filter((e) => !e.name.includes("GGG"));
          }
        } else {
          categories.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (categories.loading = false));
  };

  const topSellProducts = reactive({
    loading: false,
    data: [],
    error: "",
  });

  const getTopSellProducts = async () => {
    if (axios.isLoggedIn) {
      topSellProducts.loading = true;
      axios.authApi
        .get("/top-sell-product")
        .then((resp) => {
          if (resp.status) {
            topSellProducts.data = resp.data.data;

            // Fire Segment Event
            ProductListViewedNonLoggedIn(route, topSellProducts.data, 'trending', 1, 'home');
          } else {
            topSellProducts.error = resp.data.error;
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => (topSellProducts.loading = false));
    }
  };
  const banner = reactive({
    loading: false,
    data: [],
    name: "",
    image: "",
    error: "",
  });

  const getBanner = async () => {
    banner.loading = true;
    axios.api
      .get("/collection-details?category_slug=" + route.params.slug)
      .then((resp) => {
        if (resp.status) {
          banner.data = resp.data.data;
        } else {
          banner.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (banner.loading = false));
  };
  var page = 1;
  let sort = "";
  let stock = false;

  const category = reactive({
    loading: false,
    data: [],
    error: "",
    onScrollLoading: false,
  });

  async function getData(load) {
    let d = {};
    currentSource =  CancelToken.source();
    // const brand = store.getters.getSelected.map((r) => r.id);
    const brand = route.query.brand ? route.query.brand.split(",") : [];
    const price = route.query.price || 0;
    stock = route.query.stock || false;
    sort = route.query.sort || "";
    let dataToPost = {
      page,
      offset,
      stock,
      sort,
      brand,
      min: 0,
      max: price,
    };
    category[load] = true;
    if (axios.isLoggedIn) {
      await axios.authApi
        .get("/aCollection?category_slug=" + route.params.slug, {
          params: dataToPost,
          cancelToken: currentSource.token,
        })
        .then((res) => {
          d = res.data.data;
          if (res.data.filterOptions?.length > 0){
            const filterOptions = res.data.filterOptions;
            selectedOptions(filterOptions);
          }
        }).catch(function(error) {
          if (axiosLib.isCancel(error)) {
            return;
          }
        });
    } else {
      await axios.api
        .get("/collection?category_slug=" + route.params.slug, {
          params: dataToPost,
          cancelToken: currentSource.token,
        })
        .then((res) => {
          d = res.data.data;
          if (res.data?.filterOptions){
            const nonLoginRequiredOptions = res.data.filterOptions.filter(i => !i.login_required);
            selectedOptions(nonLoginRequiredOptions);
          }
        })
        .catch(function(error) {
          if (axiosLib.isCancel(error)) {
            return;
          }
          if (error.response && error.response.status === 403) {
            // Redirect to login if unauthorized
            window.location.href = "/login";
          }
          console.log(error);
        });
    }
    category[load] = false;
    return d;
  }

  // if route has brand query param then select those options in filter badge
  const selectedOptions = async (options) => {
    store.dispatch("updateBrandFilter", options);
    if (route.query.brand && Array.isArray(options)) {
      const selectedBrands = route.query.brand
        .toString()
        .split(",")
        .filter(Boolean);
      const alreadySelected = store.getters.getSelected.map(opt => opt.id?.toString());

      options.forEach(option => {
        if (
          option &&
          option.id !== undefined &&
          selectedBrands.includes(option.id.toString()) &&
          !alreadySelected.includes(option.id.toString())
        ) {
          store.dispatch("selectedOption", {
            ...option,
            type: "brand"
          });
        }
      });
    }
  }

  const reset = () => {
    // Cancel previous request if still in progress
    if (currentSource) {
      currentSource.cancel("Canceled due to new request");
    }
    category.data = [];
    page = 1;
  };
  async function onSortChanged(v) {
    reset();
    sort = v;
    store.dispatch("setSort", {
      previous: store.getters.getSort.current,
      current: v || "default",
      by : v,
      lastSlug: route.params.slug
    });
    category.data = await getData("loading");
  }

  async function onStockChanged(v) {
    reset();
    stock = v;
    // maxPrice(stock);
    store.dispatch("setInStock", stock);
    store.dispatch("updateBrandFilter", []);
    store.dispatch("removeOption", "clear");
  }

  async function onFilterChanged(v) {
    reset();
    const brand = store.getters.getSelected.map((r) => r.id);
    maxPrice(stock, brand);
    category.data = await getData("loading");
  }
  async function onPriceRangeChanged(v) {
    reset();
    category.data = await getData("loading");
    // store.dispatch("removeOption",'clear');
  }

  async function maxPrice(stock = false, brand = []) {
    await axios.authApi
      .get("/max-price?category_slug=" + route.params.slug, {
        params: {
          stock: stock,
          brand: brand,
        },
      })
      .then((res) => {
        if (res.data.status) {
          store.dispatch("setPriceRange", Number(res.data.data.max_price));
          store.dispatch("setMaxPrice", Number(res.data.data.max_price));
          // store.dispatch("setPriceCheck", false);
        }
      });
  }

  const scrollState = useScrollState();

  function saveScrollState() {
    scrollState.save(route.params.slug, {
      page,
      scrollY: window.scrollY,
    });
  }

  async function restoreScrollState() {
    const saved = scrollState.restore(route.params.slug);
    if (!saved) return false;

    if (saved.page > 1) {
      // Single request fetches all pages at once — this IS the initial data load
      offset = saved.page * normalOffset;
      page = 1;
      const res = await getData("loading");
      offset = normalOffset;

      if (res?.data) {
        category.data = res;
        // Recalculate last_page for normal offset (API returned it based on inflated offset)
        category.data.last_page = Math.ceil(res.total / normalOffset);
        category.data.current_page = saved.page;
        page = saved.page;
      }

      await nextTick();
      requestAnimationFrame(() => window.scrollTo({ top: saved.scrollY, behavior: 'smooth' }));
      return true; // data load handled — caller should skip its own getData
    }

    // page === 1: data load not handled, but scroll is needed after caller's getData
    // Return the scrollY so the caller can apply it after its getData completes
    return saved.scrollY;
  }

  async function handleScroll() {
    const itemsContainer = document.querySelector(".items-listing-container");
    if (!itemsContainer) {
      return;
    }
    const canLoadMore = page < category.data.last_page;
    const elemScrollHeight = itemsContainer.scrollHeight;
    const elemScrollLoadHeight = elemScrollHeight - elemScrollHeight * 0.5;
    const shouldLoadMore =
      window.pageYOffset + 200 > elemScrollLoadHeight ||
      elemScrollHeight < window.innerHeight ||
      window.pageYOffset + elemScrollLoadHeight < window.innerHeight;
    if (canLoadMore && shouldLoadMore && !category.isLoadingScrollData) {
      page++;
      category.isLoadingScrollData = true;
      const res = await getData("onScrollLoading");
      category.data.current_page = page;
      category.data.data?.push(...res.data);
      category.isLoadingScrollData = false;
    }
  }

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("beforeunload", saveScrollState);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("beforeunload", saveScrollState);
  });

  return {
    isLoggedIn: !!localStorage.getItem('LoggedUser'),
    categories,
    getCategories,
    topSellProducts,
    getTopSellProducts,
    banner,
    getBanner,
    category,
    onSortChanged,
    onStockChanged,
    onFilterChanged,
    onPriceRangeChanged,
    maxPrice,
    getData,
    reset,
    saveScrollState,
    restoreScrollState,
  };
}
